import { Tooltip } from "@mui/material";
import { StatusSolCompartilhamento } from "../../components/StatusSolCompatilhamento/StatusSolCompartilhamento";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { faArrowRight, faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StatusObraSolicitacao = ({ value, obra }) => {
    if (!value) {
        return (
            <Tooltip title="Sem necessidade de obra" placement="right">
                <div className="status_digitacao">
                    <FontAwesomeIcon icon={faX} />
                </div>
            </Tooltip>
        )
    }

    if (value && obra && obra.Situacao === 1) {
        return (
            <Tooltip title="Obra em andamento" placement="right">
                <div className="status_aguardando">
                    <FontAwesomeIcon icon={faArrowRight} />
                </div>
            </Tooltip>
        )
    }

    if (value && obra && obra.Situacao === 2) {
        return (
            <Tooltip title="Obra concluí­da" placement="right">
                <div className="status_homologado">
                    <FontAwesomeIcon icon={faCheck} />
                </div>
            </Tooltip>
        )
    }
}

const columnsSolCompartilhamento = [
    {
        field: 'Situacao',
        headerName: 'Situação',
        renderCell: (params) => (
            <StatusSolCompartilhamento value={params.value} />
        )
    },
    {
        field: 'CodigoSCObras',
        headerName: 'Situação obra',
        renderCell: (params) => (
            <StatusObraSolicitacao value={params.value} obra={params?.row?.SCObras} />
        )
    },
    {
        field: 'CodigoVisual', headerName: 'Sol. compartilhamento', flex: 1,
        renderCell: (params) => (
            <Tooltip title={params.value} placement="bottom">
                <p>{params.value}</p>
            </Tooltip>
        )
    },
    { field: 'Protocolo', headerName: 'Protocolo', flex: 1 },
    {
        field: 'Ocupante.Nome', headerName: 'Ocupante', flex: 2,
        renderCell: (params) => (
            <Tooltip title={params?.row?.Ocupante.Nome} placement="bottom">
                <p>{params?.row?.Ocupante.Nome}</p>
            </Tooltip>
        )
    },
    {
        field: 'NomeRepresentante', headerName: 'Nome', flex: 1.5,
        renderCell: (params) => {
            if (!params.value) {
                return '';
            }

            return params.value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
        }
    },
    {
        field: 'CpfRepresentante', headerName: 'CPF do representante', flex: 2,
        renderCell: (params) => {
            if (!params.value) {
                return '';
            }

            return params.value.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, "$1.$2.$3-$4");
        }
    },
    {
        field: 'DataCadastro', headerName: 'Data de cadastro', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada;
        }
    },
    {
        field: 'DataPrazoAnalise', headerName: 'Data prazo análise', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.PrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada;
        }
    },
    {
        field: 'DataAprovacao', headerName: 'Data aprovação', flex: 0.8,
        renderCell: (params) => {
            let dataFormatada = parse(params?.row?.DataAprovacao, 'dd/MM/yyyy HH:mm:ss', new Date());

            dataFormatada = format(dataFormatada, 'dd/MM/yyyy', {
                locale: ptBR
            });

            return dataFormatada;
        }
    }]

export { columnsSolCompartilhamento };